import React, { useEffect } from "react";
import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import homeFill from "@iconify/icons-eva/home-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// material
import { alpha } from "@mui/material/styles";
import {
  Avatar,
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
} from "@mui/material";
// components
import { MIconButton } from "../components/@material-extend";
import MenuPopover from "../components/MenuPopover";
import { ROUTES } from "@admin/routes/paths";
import { useAppDispatch, useAppSelector } from "@admin/redux/hooks";
import { useCheckAuthQuery, useGetUserInfoQuery } from "@admin/redux/api";
import { logout, setAuthStatus, setUserInfo } from "@admin/redux/slices/auth";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  { label: "Open Website", icon: homeFill, externalLinkTo: "/" },
  // { label: "Profile", icon: personFill, linkTo: "#" },
  // { label: "Settings", icon: settings2Fill, linkTo: "#" },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  // redux
  const { user, isAuthorized } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const { data: authCheck, refetch } = useCheckAuthQuery();
  useEffect(() => {
    refetch();
    if (authCheck != null && authCheck.is_authorized != isAuthorized) {
      dispatch(setAuthStatus(authCheck.is_authorized));
    }
  }, [isAuthorized, authCheck]);

  const { data: userInfo } = useGetUserInfoQuery();
  useEffect(() => {
    if (userInfo != null) {
      dispatch(setUserInfo(userInfo));
    }
  }, [isAuthorized, userInfo]);

  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    await dispatch(logout());
    navigate(ROUTES.auth.login);
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Avatar alt={user?.name} src={user?.image?.thumb} />
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            // to={option.linkTo}
            href={option.externalLinkTo}
            component={option.externalLinkTo ? "a" : RouterLink}
            onClick={handleClose}
            sx={{ typography: "body2", py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
